import React ,{useMemo}from 'react';
import _ from 'lodash';
import {
    Dialog, Divider, Button,Box,  DialogContent, DialogContentText, DialogTitle,Typography
} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ConfirmationDialog from './cofirmationModalTemplate';


const ConfirmBox = ({ setOpenModal, openModal, title, onConfirm, confirmMessage }) => {
    const handleClose = () => {
        setOpenModal(false);
    };
    const confirmationDialogMemo=useMemo(()=>({
        open:openModal,
        onClose:handleClose,
        mainText:title ? title : 'Delete Record',
        secondaryText:confirmMessage,
        actions:<><Button fullWidth variant='contained' color='error' onClick={onConfirm}>Yes, delete</Button>
        <Button fullWidth variant='outlined' color='secondary' onClick={handleClose}>No</Button>
        </>
    }),[openModal])
    return (
        <><ConfirmationDialog {...confirmationDialogMemo}/>
        </>

    );
}
export default ConfirmBox;
